<template>
  <div class="content-box">
    <div class="login-box">
      <div class="left-box">
        <div class="left-box-txt-zh">欢迎参赛</div>
        <div class="left-box-txt-en">Welcome to the</div>
        <div class="left-box-txt-en">CHINA BRAND DESIGN AWARDS!</div>
        <div class="left-box-txt-account">已有账号？</div>
        <div class="btn-go-login" @click="goLogin()">马上登录</div>
      </div>
      <div class="right-box">
        <div class="login-content">
          <div class="login-txt">立即注册参赛</div>
          <div class="login-txt-desc">请务必填写真实姓名</div>
          <div class="input-item">
            <div class="item-input"><input type="text" placeholder="请输入真实姓名" autocomplete="new-realName" v-model="realName"></div>
            <div class="item-label">真实姓名</div>
            <div class="item-required">*</div>
          </div>
          <div class="input-item">
            <div class="item-input"><input type="text" placeholder="请输入手机号" autocomplete="new-phone" v-model="phone"></div>
            <div class="item-label">手机号</div>
            <div class="item-required">*</div>
          </div>
          <div class="input-item" v-show="false">
            <div class="item-input">
              <input type="text" class="code" placeholder="请输入验证码" autocomplete="new-code" v-model="code">
              <div class="send-code" :class="code_time>0?'code-time':'code-btn'" @click="showCaptcha()">
                {{code_text}}
                <img src="@/assets/icon_code_send.png" v-show="iconCodeShow">
              </div>
            </div>
            <div class="item-label">验证码</div>
            <div class="item-required">*</div>
          </div>
          <div class="input-item">
            <div class="item-input"><input type="password" placeholder="请输入密码" autocomplete="new-password" v-model="password1"></div>
            <div class="item-label">密&nbsp;&nbsp;&nbsp;码</div>
            <div class="item-required">*</div>
          </div>
          <div class="protocol-box">
            <div class="protocol-checkbox">
              <img src="@/assets/checkbox_unselect.png" @click="checkRule()" :class="{'selected':!isCheckRule}">
              <img src="@/assets/checkbox_selected.png" @click="checkRule()" :class="{'selected':isCheckRule}">
              <span @click="checkRule()"> 我已阅读并同意</span>
              <span  class="protocol-txt" @click="goProtocol()">《比赛协议》</span>
            </div>
          </div>
          <div class="btn-login" @click="submitRegister()">注&nbsp;&nbsp;&nbsp;册</div>
        </div>
      </div>
    </div>
    <div id="captcha-box" v-show="isShowCaptcha"></div>
  </div>
</template>

<script>
import {Warning} from '@/plugins/warning'
import {userRegister,getCode,getImageCode,getDistrict} from "@/request/api";

const getTypeCode = (captchaType) => {
  if (!captchaType) {
    return Math.floor(Math.random() * 4) + 1
  }
  if (captchaType.toLowerCase() === 'slider') {
    return 1
  }
  if (captchaType.toLowerCase() === 'rotate') {
    return 2
  }
  if (captchaType.toLowerCase() === 'concat') {
    return 3
  }
  if (captchaType.toLowerCase() === 'word_image_click') {
    return 4
  }
  return Math.floor(Math.random() * 4) + 1
}

export default {
  name: "login",
  components:{
  },
  data() {
    return {
      isCheckRule: true,
      isShowCaptcha: false,
      iconCodeShow: true,
      realName: '',
      userName: '',
      password1: '',
      password2: '',
      phone: '',
      code: '000111',
      email: '',
      check_code: '',
      code_image: '',
      code_time: 0,
      code_text: '发送验证码',
      code_uuid: '',
      //invitationCode: '',
      //identityType: '1',
      sexType: '1',
      /*
      titleObj:{
        '1':{
          'zh':'学生组注册',
          'en':'INSTITUTION SIGN UP',
        },
        '2':{
          zh:'专业组注册',
          en:'INDIVIDUAL DESIGNER SIGN UP'
        },
      }*/
      school:'',
      address:'',
      province:-1,
      city:-1,
      dist:0,
      district:[{"id":-1,"name":"请选择"}],
      districtC:[{"id":-1,"name":"请选择"}],
      districtD:[{"id":-1,"name":"请选择"}],
    }
  },
  computed: {},
  created() {
    //const {identityType} = this.$route.query
    //this.identityType = identityType

    this.baseUrl = process.env.VUE_APP_SERVER_URL

    this.config = {
      requestCaptchaDataUrl: this.baseUrl+`/user/captcha/generate`,
      validCaptchaUrl: this.baseUrl+`/user/captcha/check`,
      bindEl: '#captcha-box',
      data: {type: getTypeCode()},
      validSuccess: (response, configuration, tac) => {
        console.log('验证成功, 后端返回的数据为', response)

        this.check_code = response.data.code;
        this.uuid = response.data.uuid;

        this.sendCode()
        tac.destroyWindow()
        this.hideCaptcha()
      },
      validFail: (response, configuration, tac) => {
        this.config.data.type = getTypeCode()
        tac.reloadCaptcha()
      },
      btnRefreshFun: (el, tac) => {
        this.config.data.type = getTypeCode()
        tac.reloadCaptcha()
      },
      btnCloseFun: (el, tac) => {
        tac.destroyWindow()
      }
    }

    this.style = {
      btnUrl: 'https://cbidcstorage.brandesign.org.cn/brand/uploads/other/tac_btn.png',
      bgUrl: 'src/background/yellow.png',
      logoUrl: 'https://cbidcstorage.brandesign.org.cn/brand/uploads/other/blank.png',
      moveTrackMaskBgColor: '#FF3B30',
      moveTrackMaskBorderColor: '#FF3B30'
    }

  },
  mounted() {
  },
  methods: {
    back(){
      history.go(-1)
    },
    radioSexFn(sexType){
      this.sexType = sexType
    },
    goLogin(){
      this.$router.push({name:'userLogin'})
    },
    checkRule(){
      this.isCheckRule = !this.isCheckRule;
    },
    goProtocol(){

    },
    submitRegister(){
      const {realName,sexType,password1/*,invitationCode,identityType*/
        ,isCheckRule,phone,code,email,province,city,dist,address,school} = this;
      if(!realName){
        Warning.open('请输入真实姓名')
        return false
      }
      if(!password1){
        Warning.open('请输入密码!')
        return false
      }
      if(!phone){
        Warning.open('请输入手机号')
        return false
      }
      if(!code){
        Warning.open('请输入短信验证码')
        return false
      }
      /*
      if(!school){
        Warning.open('请输入获奖露出信息')
        return false
      }*/
      /*
      if(identityType === '1' && !invitationCode){
        Warning.open('请输入邀请码!')
        return false
      }*/

      if(!isCheckRule){
        Warning.open('请阅读并同意《比赛协议》!')
        return false
      }
      const requestData = {
        username:phone,
        realname:realName,
        password:password1,
        //group:identityType,
        phone:phone,
        code:code,
        gender:sexType,
        email:email,
        province:province,
        city:city,
        dist:dist,
        address:address,
        school:school,
      }
      /*
      if(identityType === '1'){
        requestData.invite_code = invitationCode
      }*/
      userRegister(requestData).then((res)=>{
        this.$store.commit('infoModule/updateToken',res.data.token);
        Warning.success('注册成功，即将跳转首页')
        setTimeout(()=>{
          //const {query} = this.$route
          //this.$router.push({name:'register_success',query:{identityType,...query}})
          this.$router.push({name:'register_success'})
        },2500)
        // Warning.success('注册成功，即将跳转登录页')
        // setTimeout(()=>{
        //   this.$router.push({name:'userLogin'})
        // },2500)
      })
    },
    restCodeImage(){
      let requestData = {};
      getImageCode(requestData).then((res)=>{
        this.code_image = "data:image/png;base64,"+res.data.code;
        this.uuid = res.data.uuid;
      })
    },
    showCaptcha(){
      if(this.phone.length != 11){
        Warning.open('请输入正确的手机号码!')
        return
      }

      window.initTAC('/tac', this.config, this.style).then((tac) => {
        tac.init() // 调用init显示验证码
        this.isShowCaptcha = true
      }).catch(error => {
        console.log('initTAC fail:', error)
      })
    },
    sendCode(){
      if (this.code_time == 0){
        if(this.check_code == ''){
          Warning.open('请输入图形验证码!')
          return
        }
        if(this.phone.length != 11){
          Warning.open('请输入正确的手机号码!')
          return
        }

        let requestData = {"action":"reg","phone":this.phone,"check_code":this.check_code,"uuid":this.uuid};

        getCode(requestData).then(()=>{
          this.code_time = 60
          this.code_text = this.code_time + 's后重新发送'
          this.iconCodeShow = false;

          let clock = window.setInterval(() => {
            this.code_time--
            this.code_text = this.code_time + 's后重新发送'
            if (this.code_time <= 0) {
              window.clearInterval(clock)
              this.code_text = '发送验证码'
              this.code_time = 60
              this.iconCodeShow = true;
            }
          },1000)
        })


      }
    },
    getDistrict(){
      getDistrict({}).then((res)=>{
        this.district = res.data;
        this.district.unshift({"id":-1,"name":"请选择"});
      })
    },
    selectFn(e,key,index){
      let that = this;
      if(key == 'province'){
        //this.province = index;
        this.district.forEach(function(e) {
          if(e.id == index){
            that.districtC = e.parent;
          }
        })

        this.districtC.unshift({"id":-1,"name":"请选择"});
        this.city = -1;

        this.districtD = [{"id":-1,"name":"请选择"}];
        this.dist = -1;
      }else if(key == 'city'){
        this.districtC.forEach(function(e) {
          if(e.id == index){
            that.districtD = e.parent;
          }
        })

        this.districtD.unshift({"id":-1,"name":"请选择"});
        this.dist = -1;
      }
    },
    hideCaptcha() {
      this.isShowCaptcha = false; // ✅ 正常
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.content-box {
  width: 1440px;
  height: 925px;
  overflow: hidden;
  background: url(~@/assets/login_background.png);
  background-size: cover;
  .login-box {
    width: 936px;
    height: 537px;
    margin-top: 150px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .left-box{
      width: 400px;
      height: 100%;
      float: left;
      background: #FF3B30;
      .left-box-txt-zh{
        font-size: 24px;
        color: #FFFFFF;
        font-weight: 350;
        margin-left: 55px;
        margin-top: 130px;
      }
      .left-box-txt-en{
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 350;
        font-style: italic;
        margin-left: 55px;
      }
      .left-box-txt-account{
        font-size: 14px;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 15px;
      }
      .btn-go-login{
        width: 190px;
        height: 33px;
        cursor: pointer;
        margin-left: auto;
        margin-right: auto;
        margin-top: 25px;
        line-height: 33px;
        border-radius: 3px;
        text-align: center;
        font-size: 12px;
        color: #FF3B30;
        background: #FFFFFF;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }
    }
    .right-box{
      width: 536px;
      height: 100%;
      float: left;
      background-color: rgba(255, 255, 255, 0.8);
      .login-content{
        width: 300px;
        height: 350px;
        margin-left: 115px;
        margin-top: 80px;
        .login-txt{
          font-size: 24px;
          font-weight: 400;
          color: #3F3F3F;
        }
        .login-txt-desc{
          font-size: 14px;
          font-weight: 400;
          color: #939393;
          margin-bottom: 30px;
        }
        .input-item {
          height: 33px;
          font-size: 14px;
          margin-bottom: 15px;
          clear: left;
          .item-required{
            float: right;
            color: #FF3B30;
            height: 33px;
            line-height: 33px;
          }
          .item-label{
            float: right;
            height: 33px;
            line-height: 33px;
            text-align: right;
            margin-right: 10px;
          }
          .item-input{
            float: right;
            height: 33px;
            width: 211px;
            border-radius: 4px;
            border: 1px solid #ccc;
            & > input {
              width: 100%;
              height: 33px;
              line-height: 33px;
              font-size: 12px;
              background: transparent;
              padding-left: 10px;
              padding-right: 10px;
              border: none;
              outline: none;
              &:-webkit-autofill,
              &:-webkit-autofill:hover,
              &:-webkit-autofill:focus,
              &:-webkit-autofill:active {
                -webkit-box-shadow: 0 0 0 30px transparent inset !important;
                box-shadow: 0 0 0 30px transparent inset !important;
                background-color: transparent !important;
                background-image: none !important;
                transition: background-color 5000s ease-in-out 0s;
              }
            }
            .send-code{
              height: 33px;
              line-height: 33px;
              font-size: 10px;
              margin-right: 5px;
              cursor: pointer;
              img{
                width: 14px;
                height: 14px;
                margin-top: 10px;
                margin-right: 5px;
                float: right;
              }
            }
            .code{
              width: 130px;
              float: left;
            }
            .code-img{
              height: 28px;
              float: right;
            }
          }
        }
        .protocol-box{
          margin-left: 65px;
          margin-top: 30px;
          .protocol-checkbox{
            display: flex;
            align-items: center;
            color: #696969;
            cursor: pointer;
            img{
              width: 12px;
              height: 12px;
              float: left;
              display: none;
              margin-right: 8px;
            }
            span{
              float: left;
              font-size: 10px;
            }
            .selected{
              display: block;
            }
          }
        }
        .btn-login{
          width: 221px;
          height: 33px;
          line-height: 33px;
          margin-top: 15px;
          font-size: 12px;
          text-align: center;
          margin-left: 65px;
          color: #FFFFFF;
          cursor: pointer;
          border-radius: 4px;
          background: #FF3B30;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        }
        .btn-other{
          width: 221px;
          height: 33px;
          margin-top: 15px;
          margin-left: 65px;
          color: #696969;
          font-size: 12px;
          .save-pwd{
            display: flex;
            align-items: center;
            float: left;
            cursor: pointer;
            img{
              width: 12px;
              height: 12px;
              float: left;
              display: none;
              margin-right: 8px;
            }
            span{
              float: left;
            }
            .selected{
              display: block;
            }
          }
          .forget-pwd{
            float: right;
            cursor: pointer;
          }
        }
      }
    }
  }
  #captcha-box{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
    background-color: rgba(0, 0, 0, 0.8);
  }
}
</style>
